import { CircularProgress } from '@llt-frontend/react-material-progress';
import { NavLink } from 'react-router-dom';
import React from 'react';
import getSubjectNavigationItem from './get-subject-item';

//

function getSubjectNavigationItemList({
  addSubjectLink,
  addSubjectText,
  actions,
  editMode,
  errorLoadingText,
  failedToLoadSubjects,
  handleDeletedSubject,
  handleDeletingSubject,
  handleFailedToDeleteSubject,
  loadingText,
  navRoot,
  subjects,
  subjectType,
  subjectsLoading,
}) {
  if (subjectsLoading) {
    return [
      {
        graphic: (
          <CircularProgress data-testid={`${subjectType}-nav-loading-indicator`} size="medium" />
        ),
        component: 'div',
        primaryText: loadingText,
      },
    ];
  }

  if (failedToLoadSubjects) {
    return [
      {
        className: 'mdc-deprecated-list-item--error',
        component: 'div',
        disabled: true,
        graphic: 'report',
        primaryText: errorLoadingText,
      },
    ];
  }

  const subjectItems = subjects.map(function _mapSubjectsToNavListItems(subject) {
    return getSubjectNavigationItem({
      actions,
      editMode,
      handleDeletedSubject,
      handleDeletingSubject,
      handleFailedToDeleteSubject,
      navRoot,
      subject,
    });
  });

  const navigationItems = subjectItems;

  if (actions.includes('add')) {
    navigationItems.push({
      activeClassName: 'mdc-deprecated-list-item--selected',
      className: 'mdc-deprecated-list-item--add',
      component: NavLink,
      exact: false,
      graphic: 'add_circle_outline',
      primaryText: addSubjectText,
      to: addSubjectLink,
    });
  }

  return navigationItems;
}

// Exports
// -------

export default getSubjectNavigationItemList;
